import {
  Box,
  Button,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import DeleteIcon from '@mui/icons-material/Delete';
import ErrorMessage from '@/components/errorMessage';
import EmittedCustomEvent from './emittedCustomEvent';
import { eventNameEquals } from '@/utils';

type Props = {
  emittedEventDefs: any[];
  maxHeight?: number;
  onAddCustomEvent: (customEvent: any) => void;
  onDeleteCustomEvent: (customEvent: any) => void;
};

const EmittedEventDefs = ({ emittedEventDefs = [], onAddCustomEvent, onDeleteCustomEvent }: Props) => {
  const [newCustomEvent, setNewCustomEvent] = useState(false);
  const [newCustomEventError, setNewCustomEventError] = useState('');

  const addNewCustomEvent = () => {
    setNewCustomEventError('');
    setNewCustomEvent(true);
  };

  const addCustomEvent = (customEvent: any) => {
    const ce = (emittedEventDefs || []).find(
      (ee: any) => eventNameEquals(ee.eventName, customEvent.eventName) && ee.eventType === 'CustomEvents',
    );
    if (!ce) {
      onAddCustomEvent(customEvent);
      setNewCustomEvent(false);
      setNewCustomEventError('');
    } else {
      setNewCustomEventError('Already exists');
    }
  };

  const cancelAdd = () => {
    setNewCustomEventError('');
    setNewCustomEvent(false);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.5 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
          Emitted Events
        </Typography>
        <Button
          variant="contained"
          size="small"
          color="secondary"
          onClick={() => addNewCustomEvent()}
          disabled={newCustomEvent}
          sx={{ textTransform: 'none', fontWeight: 700, borderRadius: '8px', boxShadow: 'none' }}
        >
          Add Custom Event
        </Button>
      </Stack>

      <Box sx={{ flex: 1, overflow: 'auto' }}>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', fontWeight: 700 }}>
                  Event Name
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', fontWeight: 700 }}>
                  Event Label
                </TableCell>
                <TableCell sx={{ borderRight: '1px solid', borderColor: 'divider', fontWeight: 700 }}>
                  Event Type
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {newCustomEvent && (
                <EmittedCustomEvent onAdd={addCustomEvent} onCancelAdd={cancelAdd} errror={newCustomEventError} />
              )}
              {newCustomEventError && (
                <TableRow>
                  <TableCell colSpan={4}>
                    <ErrorMessage error={{ message: newCustomEventError }} />
                  </TableCell>
                </TableRow>
              )}
              {(emittedEventDefs || []).map((emittedEventDef: any, idx: any) => {
                return (
                  <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} key={idx}>
                    <TableCell>{emittedEventDef.eventName}</TableCell>
                    <TableCell>{emittedEventDef.eventLabel}</TableCell>
                    <TableCell>{emittedEventDef.eventType}</TableCell>
                    <TableCell align="right">
                      {emittedEventDef.eventType === 'CustomEvents' && (
                        <IconButton size="small" onClick={() => onDeleteCustomEvent(emittedEventDef)} color="error">
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Box>
  );
};

export default EmittedEventDefs;
